import { EListingModalActionType, EOffersFetchingMode } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setOffersFetchingMode = actionGenerator<
  EListingModalActionType.SetOffersFetchingMode,
  EOffersFetchingMode
>(EListingModalActionType.SetOffersFetchingMode);
